import React, { Component } from 'react';
import PageTitle from '../home/PageTitle';

class Test extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Message: 'Hello World',
            Name: 'Mainak',
            Age:0,
        }
    }
    onChangeHandler=(e)=>{
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {     
        var {Name, Age} =this.state;
        return (
            <>
                <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                    <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
                        <div className="col-md-9 justify-content-start">
                            <PageTitle Title="Manage Test" />
                        </div>
                        <div className="col-md-3 text-right pt-1">
                            <button className="btn btn-outline-dark btn-sm px-3 mx-3" title="Refresh">
                                <i className="fa-solid fa-arrows-rotate"></i> Refresh
                            </button>
                            <button className="btn btn-outline-primary btn-sm px-3 cursor-pointer" title="Add" >
                                <i className="fa-solid fa-plus"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid py-4 mt-115">
                    <div className="row">
                        <div className="col-sm-12">
                            <h1>{this.state.Message}</h1>
                            <h3>My name is {Name} and my age is {Age}</h3>
                            <span>Enter Name:</span>
                            <input type='text' name="Name" style={{border: "1px solid"}} onChange={this.onChangeHandler}/>
                            <br/>
                            <span>Enter Age:</span>
                            <input type='text' name="Age" style={{border: "1px solid"}} onChange={this.onChangeHandler}/>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Test;